export type BuyerVenueSteps = {
  name:
    | "VenueTypeStep"
    | "OwnershipTypeStep"
    | "ConfirmationStep"
    | "VenueTypeStepOther";
  step: number | null;
};

export let BuyerVenueSteps: {
  VenueTypeStep: BuyerVenueSteps;
  OwnershipTypeStep: BuyerVenueSteps;
  ConfirmationStep: BuyerVenueSteps;
  VenueTypeStepOther: BuyerVenueSteps;
} = {
  VenueTypeStep: {
    name: "VenueTypeStep",
    step: 0,
  },
  VenueTypeStepOther: {
    name: "VenueTypeStepOther",
    step: 0,
  },
  OwnershipTypeStep: {
    name: "OwnershipTypeStep",
    step: 1,
  },
  ConfirmationStep: {
    name: "ConfirmationStep",
    step: null,
  },
};
